import { useEffect, useState } from 'react';

// Faixa persistente de "sem conexão". No navegador é redundante (o próprio
// navegador já sinaliza isso), mas essencial no app nativo — não existe
// barra de navegador ali para avisar o usuário.
export const OfflineNotice = () => {
    const [isOffline, setIsOffline] = useState(() => typeof navigator !== 'undefined' && !navigator.onLine);

    useEffect(() => {
        const goOffline = () => setIsOffline(true);
        const goOnline = () => setIsOffline(false);
        window.addEventListener('offline', goOffline);
        window.addEventListener('online', goOnline);
        return () => {
            window.removeEventListener('offline', goOffline);
            window.removeEventListener('online', goOnline);
        };
    }, []);

    if (!isOffline) return null;

    return (
        <div
            role="status"
            className="fixed top-0 inset-x-0 z-[60] pt-safe-top bg-error text-on-error text-center text-sm font-bold py-2"
        >
            Sem conexão com a internet
        </div>
    );
};
